const Home = resolve => require(['./components/Home.vue'], resolve);
const About = resolve => require(['./components/About.vue'], resolve);
const Game = resolve => require(['./components/Game.vue'], resolve);
const Business = resolve => require(['./components/Business.vue'], resolve);
const News = resolve => require(['./components/News.vue'], resolve);
const Store = resolve => require(['./components/Store.vue'], resolve);
const Consume = resolve => require(['./components/store/Consume.vue'], resolve);
const Recharge = resolve => require(['./components/store/Recharge.vue'], resolve);
const Records = resolve => require(['./components/store/Records.vue'], resolve);
const NewsDetail = resolve => require(['./components/NewsDetail.vue'], resolve);
const Result = resolve => require(['./components/Result.vue'], resolve);
const Notice = resolve => require(['./components/Notice.vue'], resolve);
const Refund = resolve => require(['./components/notice/Refund.vue'], resolve);
export default [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/result',
        meta: {auth: false},
        component: Result
    },
    {
        path: '/home',
        meta: {auth: false},
        component: Home
    },
    {
        path: '/about',
        meta: {auth: false},
        component: About
    },
    {
        path: '/game',
        meta: {auth: false},
        component: Game
    },
    {
        path: '/business',
        meta: {auth: false},
        component: Business
    },
    {
        path: '/news',
        meta: {auth: false},
        component: News,
    },
    {
        path: '/news/:id',
        meta: {auth: false},
        component: NewsDetail,
    },
    {
        path: '/store',
        component: Store,
        children: [
            {
                path: '',
                redirect: 'recharge'
            },
            {
                path: 'consume',
                meta: {auth: false},
                component: Consume,
            },
            {
                path: 'recharge',
                meta: {auth: false},
                component: Recharge,
                name: 'recharge'
            },
            {
                path: 'records/:type',
                meta: {auth: true},
                component: Records
            },
            {
                path: '*',
                redirect: 'consume'
            },
        ]
    },
    {
        path: '/notice/',
        component: Notice,
        children: [
            {
                path: '',
                redirect: 'refund'
            },
            {
                path: 'refund',
                meta: {auth: false},
                component: Refund,
            },
            {
                path: '*',
                redirect: 'refund'
            },
        ]
    },
    {
        path: '*',
        redirect: 'home'
    },
]



// WEBPACK FOOTER //
// ./src/routes.js